<template>
  <div v-if="Object.entries(service_point.time_slots).length" class="font-14-991">
    <b-popover :target="`opening_hour_${service_point.id}`" triggers="hover" placement="top" :custom-class="'custom-popover-opening-hour'">
      <div class="popover-opening-hour-container">
        <table class="opening-hour-table">
          <tr>
            <td colspan="2">
              <p class="mb-1 px-2 font-weight-bold font-16">{{ $t('Opening hours') }}</p>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t("Monday") }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 2) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 2)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Tuesday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 3) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 3)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Wednesday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 4) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 4)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Thursday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 5) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 5)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Friday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 6) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 6)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Saturday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 7) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 7)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
          <tr>
            <td class="day-name">{{ $t('Sunday') }}</td>
            <td class="timing-hours">
              <template v-if="displayStartAndEndTime(service_point.time_slots, 1) !== ''">
                {{displayStartAndEndTime(service_point.time_slots, 1)}}
              </template>
              <template v-else>{{ $t('Closed') }}</template>
            </td>
          </tr>
        </table>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "HomepageOpeningHourPopover",
  props : ["service_point"],
  methods : {
    displayStartAndEndTime(timeslots, day_number) {
      var start_end_time = '';
      try {
        if (timeslots && day_number) {
          var day = timeslots.find(timeslot => timeslot.day_id === day_number)
          if (typeof day === 'object' && day !== null && 'start_time' in day && 'end_time' in day) {
            start_end_time += day.start_time.slice(0, -3) + " - " + day.end_time.slice(0, -3)
          }
        }
      } catch (e) {
        return '';
      }

      return start_end_time;
    }
  }
}
</script>